export function isValidEmail(email: string): boolean {
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
}

export function isValidNigerianPhone(phone: string): boolean {
  const cleaned = phone.replace(/\s/g, "");
  return /^(\+?234|0)[7-9][0-1][0-9]{8}$/.test(cleaned);
}

export function cleanPhone(phone: string): string {
  return phone.replace(/\D/g, "").replace(/^0/, "234");
}

export function isValidLogoFile(file: File): { valid: boolean; error?: string } {
  const validTypes = ["image/png", "image/svg+xml", "application/pdf"];
  if (!validTypes.includes(file.type)) {
    return { valid: false, error: "Only PNG, SVG, or PDF files allowed" };
  }
  if (file.size > 5 * 1024 * 1024) {
    return { valid: false, error: "File must be under 5MB" };
  }
  return { valid: true };
}

export function validateImageDimensions(file: File, minWidth = 300, minHeight = 300): Promise<{ valid: boolean; error?: string }> {
  return new Promise((resolve) => {
    if (file.type === "image/svg+xml" || file.type === "application/pdf") {
      resolve({ valid: true });
      return;
    }
    const img = new Image();
    img.onload = () => {
      if (img.width < minWidth || img.height < minHeight) {
        resolve({ valid: false, error: `Image must be at least ${minWidth}x${minHeight}px` });
      } else {
        resolve({ valid: true });
      }
    };
    img.onerror = () => resolve({ valid: false, error: "Could not read image dimensions" });
    img.src = URL.createObjectURL(file);
  });
}

export interface ValidationErrors {
  [key: string]: string;
}

export function validateRequiredFields(data: Record<string, unknown>, fields: string[]): ValidationErrors {
  const errors: ValidationErrors = {};
  for (const field of fields) {
    const value = data[field];
    if (!value || (typeof value === "string" && value.trim() === "")) {
      errors[field] = `${field.charAt(0).toUpperCase() + field.slice(1)} is required`;
    }
  }
  return errors;
}
